import JsonResponse from "csi/comm/JsonResponse";
import { ControllerSaveFunction } from "csi/middleware/common";
import { C8Node } from "csi/typings";
import { ReactionStore } from "csi/utility/mobxUtility";
import Writer from "csi/xml/Writer";
import _ from "lodash";
import { action, makeObservable } from "mobx";
import { createContext, useContext } from "react";
import { notifyCollaborators } from "./NotifyCollaboratorsService";

export default class NotifyCollaboratorsStore extends ReactionStore {
	readonly onSave: ControllerSaveFunction;
	private readonly writer: Writer;
	private readonly latestRevisionNode: C8Node;

	constructor(writer: Writer, latestRevisionNode: C8Node, onSave?: ControllerSaveFunction) {
		super();
		makeObservable(this);
		this.onSave = onSave;
		this.writer = writer;
		this.latestRevisionNode = latestRevisionNode;
	};

    /** finish the Dialog */
    @action onConfirm = async (): Promise<void> => {
    	const promise = this.onConfirmSave();
    	await this.onSave(promise);
    };

    /**
	 * Promise to send the request to Notify Collaborators
	 */
    public onConfirmSave = async (): Promise<JsonResponse> => {
    	const { writer, latestRevisionNode } = this;
    	try {
    		const res = await notifyCollaborators(writer, latestRevisionNode);
    		return res;
    	} catch (err) {
    		throw err;
    	}
    };
}

export const NotifyCollaboratorsStoreContext = createContext<NotifyCollaboratorsStore>(undefined);
export const useNotifyCollaboratorsStore = (): NotifyCollaboratorsStore => useContext(NotifyCollaboratorsStoreContext);